"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Error_1 = __importDefault(require("@material-ui/icons/Error"));
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
const utils_1 = require("utils");
function AuthorizationError() {
    const location = (0, react_router_dom_1.useLocation)();
    const { search } = location;
    const query = (0, utils_1.parseQuery)(search);
    const applicationPath = query[config_1.QUERY_KEY.APPLICATION_PATH];
    const errorDescription = query[config_1.QUERY_KEY.ERROR_DESCRIPTION];
    let AuthorizationErrorComponent;
    switch (query[config_1.QUERY_KEY.ERROR]) {
        case config_1.ERROR_STATUS_NAME.UNAUTHORIZED:
            AuthorizationErrorComponent = UserAuthorizationError;
            break;
        default:
            AuthorizationErrorComponent = AuthorizationServiceError;
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "page-container centered-container", children: (0, jsx_runtime_1.jsxs)("div", { className: "error-page-container", children: [(0, jsx_runtime_1.jsx)(Error_1.default, { style: { fontSize: 100 }, color: "disabled" }), (0, jsx_runtime_1.jsx)(AuthorizationErrorComponent, { applicationPath, errorDescription })] }) }));
}
exports.default = (0, react_1.memo)(AuthorizationError);
function UserAuthorizationError({ applicationPath, errorDescription, }) {
    const errorMessage = errorDescription?.includes('blocked')
        ? 'Your account has been disabled. Please contact your administrator if you believe your account should be active.'
        : 'You are unauthorized. Please contact your administration if you believe this is an error.';
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h4", { className: "error-page-title", children: "Unauthorized Request" }), (0, jsx_runtime_1.jsx)("p", { className: "error-page-paragraph", children: errorMessage }), (0, jsx_runtime_1.jsx)(lp_components_1.Button, { className: "button-warn-outline", onClick: () => (0, utils_1.forceRedirect)({ to: applicationPath }), children: "Retry Login" })] }));
}
function AuthorizationServiceError({ errorDescription, }) {
    const history = (0, react_router_dom_1.useHistory)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h4", { className: "error-page-title", children: "Authorization Service Error" }), (0, jsx_runtime_1.jsxs)("p", { className: "error-page-paragraph", children: ["Oops. It appears that the authorization service returned an error: [", errorDescription, "] If you believe this is an error please contact us."] }), (0, jsx_runtime_1.jsx)(lp_components_1.Button, { className: "button-warn-outline", onClick: () => history.goBack(), children: "Go Back" })] }));
}
